import Model, { attr } from '@ember-data/model';

export default class SerpResultFeatured extends Model {
  @attr('string') url;
  @attr('string') title;
}
